export default {
  set(accessToken, refreshToken) {
    sessionStorage.setItem("enrolhqAccessToken", accessToken);
    sessionStorage.setItem("enrolhqRefreshToken", refreshToken);
  },
  getRefreshToken() {
    return sessionStorage.getItem("enrolhqRefreshToken");
  },
  getAccessToken() {
    return sessionStorage.getItem("enrolhqAccessToken");
  },
  clear() {
    sessionStorage.removeItem("enrolhqAccessToken");
    sessionStorage.removeItem("enrolhqRefreshToken");
  },
};
